import { Injectable } from '@angular/core';
import { Chats } from '../interfaces/chatData';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatsService {

  baseApiCatalog = environment.baseApi + '/catalog';
  baseApiChats = environment.baseApi + '/chats';
  private nombresActualizadosSource = new BehaviorSubject<{ chatId: string, nuevoNombre: string } | null>(null);
  nombresActualizados$ = this.nombresActualizadosSource.asObservable();

  constructor(private http: HttpClient) { }


  getChats(type: string) {
    return this.http.get<any>(`assets/${type}.json`)
      .toPromise()
      .then(res => <Chats[]>res.data)
      .then(data => { return data; });
  }

  obtenerStatus(idCustomer: number) {
    return this.http.get<any>(`${this.baseApiCatalog}/status/${idCustomer}`).toPromise();
  }

  searchChats(term: string, idSuscription: number, pageNumber: number, pageSize: number, idUser?: any) {
    // Configura los parámetros de la solicitud
    let params = new HttpParams()
      .set('term', term)
      .set('idSuscription', idSuscription.toString())
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString())
  
    // Si idUser no es null o undefined, lo incluye en los parámetros
    if (idUser !== null && idUser !== undefined) {
      params = params.set('idUser', idUser.toString());
    }
    
    // Realiza la solicitud HTTP GET
    return this.http.get<any>(`${this.baseApiChats}/search`, { params }).toPromise();
  }
  

  updateStatus(idSuscription: number | null, chatId: string | undefined, idStatus: number | null | undefined) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.put<Response>(`${this.baseApiChats}/change-status/${idSuscription}/${chatId}/${idStatus}`, { headers })
  }

  editContactName(idSuscription: number, chatId: string | undefined, body: string | undefined) {
    const headers = new HttpHeaders(); 
    return this.http.put<Response>(`${this.baseApiChats}/edit-contact-name/${idSuscription}/${chatId}`, body, { headers });
  }
  
  actualizarNombreContacto(chatId: any, nuevoNombre: any) {
    this.nombresActualizadosSource.next({ chatId, nuevoNombre });
  }

}
